import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { Observable } from 'rxjs';
import { TaskDocChangeTaskRequest } from 'src/app/features/transport-operation/components/frontline-document/interface/front-line-doc-change-task-reuqest';
import { TaskDocResetLockRequest } from 'src/app/features/transport-operation/components/frontline-document/interface/front-line-doc-reset-lock-request';
import { SearchTaskDocDetailResponse } from 'src/app/features/transport-operation/components/frontline-document/interface/search-front-doc-detail-response';
import { environment } from 'src/environments/environment';
import { TaskListOptions } from '../models/options/task-list-options';
import { TaskDocConfirmRequest } from './../../features/transport-operation/components/frontline-document/interface/front-line-doc-confirm.request';
import { SearchTaskDocHeaderResponse } from './../../features/transport-operation/components/frontline-document/interface/search-frontline-doc-header-response';
import { SearchTaskDocHeaderRequest } from 'src/app/features/transport-operation/components/frontline-document/interface/search-frontline-doc-header-request';
import { FrontLineDocReturnRequest } from 'src/app/features/transport-operation/components/frontline-document/interface/front-line-doc-return-request';
import { FrontLineDocReturnConfirmRequest } from 'src/app/features/transport-operation/components/frontline-document/interface/front-line-doc-return-confirm-request';
import { FrontLineDocReturnResponse } from 'src/app/features/transport-operation/components/frontline-document/interface/front-line-doc-return-response';
import { isNullOrEmpty } from '../utils/common-functions';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FrontlineDocumentService {

  constructor(private http: HttpClient) {}

  getTaskOptions(lang: string, taskClassName: string): Observable<TaskListOptions[]> {
    const url = `${environment.logisticsApiUrl}/taskDocument/getTaskOptions/${lang}/${taskClassName}`;
    return this.http.get<TaskListOptions[]>(url);
  }

  searchHeader(req: SearchTaskDocHeaderRequest): Observable<SearchTaskDocHeaderResponse[]> {
    const url = `${environment.logisticsApiUrl}/taskDocument/searchTaskDocHeader`;
    return this.http.post<SearchTaskDocHeaderResponse[]>(url, req);
  }

  searchDetail(request: SearchTaskDocHeaderResponse): Observable<SearchTaskDocDetailResponse[]> {
    const url = `${environment.logisticsApiUrl}/taskDocument/searchTaskDocDetail`;
    return this.http.post<SearchTaskDocDetailResponse[]>(url, request);
  }

  changeTask(request: TaskDocChangeTaskRequest): Observable<void> {
    const url = `${environment.logisticsApiUrl}/taskDocument/changeTask`;
    return this.http.post<void>(url,request);
  }
  confirmDo(request: TaskDocConfirmRequest): Observable<void> {
    const url = `${environment.logisticsApiUrl}/taskDocument/confirmDo`;
    return this.http.post<void>(url,request);
  }

  resetDoLockStatus(request: TaskDocResetLockRequest): Observable<void> {
    const url = `${environment.logisticsApiUrl}/taskDocument/resetDoLockStatus`;
    return this.http.post<void>(url, request);
  }

  checkConfirmStatus(doNo: string, doLockHeader: string | null, taskClassName: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/taskDocument/checkConfirmStatus/${doNo}/${isNullOrEmpty(doLockHeader) ? '' : doLockHeader}/${taskClassName}`;
    return this.http.get(url);
  }

  searchHeaderByBookingNo(req: SearchTaskDocHeaderRequest): Observable<SearchTaskDocHeaderResponse[]> {
    const url = `${environment.logisticsApiUrl}/taskDocument/searchTaskDocHeaderByBookingNo`;
    return this.http.post<SearchTaskDocHeaderResponse[]>(url, req);
  }

  applyFrontLineDocReturn(req: FrontLineDocReturnRequest): Observable<FrontLineDocReturnResponse> {
    const url = `${environment.logisticsApiUrl}/taskDocument/applyFrontLineDocReturn`;
    return this.http.post<FrontLineDocReturnResponse>(url, req);
  }

  replyFrontLineDocReturn(req: FrontLineDocReturnConfirmRequest): Observable<FrontLineDocReturnResponse> {
    const url = `${environment.logisticsApiUrl}/taskDocument/replyFrontLineDocReturn`;
    return this.http.post<FrontLineDocReturnResponse>(url, req);
  }
}
